export default {"src":"/_next/static/media/signed-doc.908efb03.svg","height":209,"width":226,"blurWidth":0,"blurHeight":0};